import { Model } from 'vue-mc';
import { PartnerApi } from '@/api/PartnerApi.js';

export default class Partner extends Model {
  defaults() {
    return {
      id: null,
      theme: "chuspic",
      font_family: "roboto",
      logo_url: "",
      facebook_url: "",
      instagram_url: "",
      twitter_url: "",
      tiktok_url: "",
      contact_phone: "",
      contact_email: "",
      register_user: true,
      sales: false,
      share_social_media: false,
      require_avatar: false,
      currency: "",
      footer: true,
      last_events: true,
      analytics_url: null,
      colors: {}
    }
  }

  async fetch() {
    return await PartnerApi.fetch();
  }

  font() {
    return this.font_family
  }

  fontBold() {
    return `${this.font()}_bold`
  }

  fontLight() {
    return `${this.font()}_light`
  }

  hasFacebook() {
    return this.facebook_url != null && this.facebook_url.length > 0
  }

  hasInstagram() {
    return this.instagram_url != null && this.instagram_url.length > 0
  }

  hasTwitter() {
    return this.twitter_url != null && this.twitter_url.length > 0
  }

  hasTiktok() {
    return this.tiktok_url != null && this.tiktok_url.length > 0
  }

  hasPhone() {
    return this.contact_phone != null && this.contact_phone.length > 0
  }

  hasAnalytics() {
    return this.analytics_url != null && this.analytics_url.length > 0
  }
};